@if (!loading) {
  <router-outlet></router-outlet>
}
